var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.currentImage)?_c('img',{key:_vm.currentImage,attrs:{"src":_vm.currentImageSrc}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }